import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { LOCALES } from '@whitbread-eos/api';
var ONE_TRUST_CONFIG_BY_LOCALE = {
  [LOCALES.EN]: {
    dataLanguage: 'en',
    getDomainScript: () => process.env.NEXT_PUBLIC_ONE_TRUST_DOMAIN_SCRIPT_GB
  },
  [LOCALES.DE]: {
    dataLanguage: 'de',
    getDomainScript: () => process.env.NEXT_PUBLIC_ONE_TRUST_DOMAIN_SCRIPT_DE
  }
};
var LOCALE_MATCHERS = {
  [LOCALES.EN]: [LOCALES.EN, '/gb/en', 'en', 'gb'],
  [LOCALES.DE]: [LOCALES.DE, '/de/de', 'de']
};
export var getCanonicalLocale = urlOrPath => {
  var _urlOrPath$toLowerCas, _Object$entries$find;
  var value = (_urlOrPath$toLowerCas = urlOrPath === null || urlOrPath === void 0 ? void 0 : urlOrPath.toLowerCase()) !== null && _urlOrPath$toLowerCas !== void 0 ? _urlOrPath$toLowerCas : '';
  var localeMatch = (_Object$entries$find = Object.entries(LOCALE_MATCHERS).find(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      matchers = _ref2[1];
    return matchers.some(matcher => value === matcher || value.includes(matcher));
  })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0];
  return localeMatch !== null && localeMatch !== void 0 ? localeMatch : LOCALES.EN;
};
export var getOneTrustConfigByLocale = locale => {
  var localeConfig = ONE_TRUST_CONFIG_BY_LOCALE[locale];
  return {
    dataLanguage: localeConfig.dataLanguage,
    domainScript: localeConfig.getDomainScript()
  };
};
export var isOneTrustCookieConsentActive = (isFeatureEnabled, localeOrPath) => {
  var _getOneTrustConfigByL = getOneTrustConfigByLocale(getCanonicalLocale(localeOrPath)),
    domainScript = _getOneTrustConfigByL.domainScript;
  return !!(isFeatureEnabled && process.env.NEXT_PUBLIC_ONE_TRUST_SCRIPT_URL && domainScript);
};